/*
 *  Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .controller('NodeMembersController', [
        '$scope', '$modalInstance', 'element', 'operationComplete', 'template', 'NodeMember', 'SortingService', 'nodeMembersModal', 'SyncAndShareNode', '$translate',
        function ($scope, $modalInstance, element, operationComplete, template, NodeMember, SortingService, nodeMembersModal, SyncAndShareNode, $translate) {
            $scope.modal = $modalInstance.options;
            $scope.modal.footerTemplate = template('nodes/_members_modal_footer');
            $scope.element = $scope.node = $scope.currentNode = element;
            $scope.members = [];
            $scope.table = {
                sorting: SortingService['new']('email'),
                loading: true
            };
            $scope.inheritedMemberTooltip = $translate.instant("This setting is inherited from a higher-level shared folder and must be edited in that folder's Members list.");
            $scope.shareOptions = {
                uuid: $scope.node.uuid,
                expiration_date: $scope.node.expirationDate,
                allow_guest_downloads: $scope.node.allowGuestDownloads
            };

            _reloadMembers();

            $scope.update = function (member) {
                $scope.modal.loading = true;

                if (member.read_only) {
                    member.can_invite = false;
                    member.can_view_members = false;
                }

                member.$update({node_uuid: $scope.element.uuid}, () => {
                    _reloadPermissions(() => $scope.modal.loading = false)
                });
            };

            $scope.remove = function (member) {
                $scope.modal.loading = true;
                member.$delete({node_uuid: $scope.element.uuid}, function () {
                    if (member.isGroup()) {
                        operationComplete(
                            "members_dialog_remove_member_group_success_message",
                            {share_group_name: member.name}
                        );
                    } else {
                        operationComplete(
                            "Successfully removed access to folder for user '%{uninvited_user_email}'.",
                            {uninvited_user_email: member.email}
                        );
                    }
                    $scope.members.splice($scope.members.indexOf(member), 1);

                    if ($scope.members.length === 0) {  // no more members but owner - node is not longer shared, so we close and reload
                        $modalInstance.close('reload_nodes');
                    } else {
                        _reloadPermissions(() => $scope.modal.loading = false)
                    }
                });
            };

            $scope.removeAll = function () {
                $scope.modal.loading = true;
                NodeMember.removeAll({node_uuid: $scope.element.uuid}, function () {
                    operationComplete(
                        "Successfully removed all shared access for node '%{node_name}'.",
                        {node_name: $scope.element.name}
                    );
                    $modalInstance.close('reload_nodes');
                    $scope.modal.loading = false;
                });
            };

            $scope.close = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.done = function () {
                if (_shareOptionsChanged()) {
                    $scope.modal.loading = true;

                    $scope.node
                        .update($scope.shareOptions)
                        .finally(function () {
                            $scope.modal.loading = false;
                            $modalInstance.close('reload_nodes');
                        });
                } else {
                    $scope.close();
                }
            };

            $scope.disableSubmit = function () {
                return $scope.modal.loading ||
                    ($scope.node.isCurrentUserOwner($scope.account) && angular.isUndefined($scope.shareOptions.expiration_date));
            };

            $scope.sortColumn = function (index) {
                $scope.table.sorting.setColumn(index);
                _reloadMembers();
            };

            $scope.canEdit = function () {
                if ($scope.modal.loading || $scope.table.loading) {
                    return false;
                }

                return $scope.element.permissions['can_be_shared'];
            };

            $scope.openMembersDialog = function (node) {
                $scope.modal.loading = true;
                var isolatedScope = $scope.$new(true);

                SyncAndShareNode.get({uuid: (node.uuid)}).$promise.then(function (data) {
                    isolatedScope.node = data;
                    nodeMembersModal(isolatedScope).then(_reloadMembers, _reloadMembers);
                    $scope.modal.loading = false;
                });
            };

            function _shareOptionsChanged() {
                return $scope.shareOptions.expiration_date !== $scope.node.expirationDate ||
                    $scope.shareOptions.allow_guest_downloads !== $scope.node.allowGuestDownloads;
            }

            function _reloadMembers() {
                $scope.table.loading = true;

                NodeMember
                    .query(
                        angular.extend({node_uuid: $scope.element.uuid}, $scope.table.sorting.getQueryParams()),
                        data => {
                            $scope.members = data.filter((m) => !m.isOwner());
                            $scope.table.loading = false;
                        }
                    )
            }

            function _reloadPermissions(afterReload) {
                SyncAndShareNode
                    .getPermissions(
                        {uuid: $scope.element.uuid},
                        (data) => {
                            $scope.element.permissions = data;

                            if ($scope.element.permissions['can_view_members'] !== true) {
                                $modalInstance.close('reload_nodes');
                            } else {
                                afterReload();
                            }
                        },
                        () => $modalInstance.close('reload_nodes')
                    )
            }
        }
    ]);
